<template>
  <div
    class="section"
    style="font-size: .90rem"
  >

    <p>Count: {{ $store.state.allUsers.length | number(0) }}</p>

    <b-table
      :data="isEmpty ? [] : $store.state.allUsers"
      :narrowed="false"
      :hoverable="true"
      :selected.sync="selected"
      :paginated="false"
      :per-page="20"
      @select="setActiveRow"
    >

      <template slot-scope="props">
        <b-table-column
          field="firstName"
          label="First Name"
          sortable
        >
          {{ props.row.firstName }}
        </b-table-column>

        <b-table-column
          field="lastName"
          label="Last Name"
          sortable
        >
          {{ props.row.lastName }}
        </b-table-column>

        <b-table-column
          field="email"
          label="Email"
          sortable
        >
          {{ props.row.email }}
        </b-table-column>

        <b-table-column
          field="password"
          label="Password"
        >
          {{ props.row.password }}
        </b-table-column>

        <b-table-column
          field="isAdmin"
          label="Admin"
          sortable
        >
          <p v-if="props.row.isAdmin">Admin</p>
        </b-table-column>

        <b-table-column
          field="isAgent"
          label="Agent"
          sortable
        >
          <p v-if="props.row.isAgent">Agent</p>
        </b-table-column>

        <b-table-column
          field="isSearchFree"
          label="Search (free)"
          sortable
        >
          <p v-if="props.row.isSearchFree">Search (free)</p>
        </b-table-column>

        <b-table-column
          field="controls"
          label=""
          centered
        >

          <div class="columns">
            <div class="column">
              <b-tooltip label="Edit user">
                <a
                  class="fas fa-edit"
                  @click="edit()"
                ></a>
              </b-tooltip>
            </div>
          </div>

        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                icon="emoticon-happy"
                size="is-large"
              >
              </b-icon>
            </p>
          </div>
        </section>
      </template>

    </b-table>

    <b-modal
      :active.sync="isEditUserActive"
      has-modal-card
      :canCancel="[]"
    >
      <EditUser v-bind:userToEdit="
      activeUser">
      </EditUser>
    </b-modal>

  </div>
</template>

<script>
import EditUser from "@/components/admin/EditUser.vue";

export default {
  components: {
    EditUser
  },

  props: {
    open: false
  },

  data() {
    return {
      activeUser: undefined,
      selected: undefined,
      isEmpty: undefined,
      isEditUserActive: false
    };
  },

  mounted() {
    console.log("mounted");
    var userId = this.$store.getters.session.user.id;
    var includeHidden = true;
    this.$store.dispatch("getUserConnections", {
      userId,
      includeHidden
    });
    this.$store.dispatch("getAllUsers");
  },

  methods: {
    edit() {
      console.log("edit()");
      this.isEditUserActive = true;
    },

    setActiveRow(row) {
      console.log("setActiveRow", row);
      this.activeUser = row;
    }
  }
};
</script>

<style>
</style>
